import { render, staticRenderFns } from "./crmLoader.vue?vue&type=template&id=495428b0&scoped=true"
import script from "./crmLoader.vue?vue&type=script&lang=js"
export * from "./crmLoader.vue?vue&type=script&lang=js"
import style0 from "./crmLoader.vue?vue&type=style&index=0&id=495428b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495428b0",
  null
  
)

export default component.exports